import type { EvaluationContextValue } from "@openfeature/core";

/** How a context of type `C` is sent to the provider: its kind, targeting key and attributes. */
export interface FlagContextType<C> {
  readonly kind: string;
  readonly targetingKey: (context: C) => string;
  readonly attributes?: (
    context: C,
  ) => Readonly<Record<string, EvaluationContextValue>>;
}

/** Defines a context type; `C` is the shape call sites pass. */
export function flagContext<C>(
  definition: FlagContextType<C>,
): FlagContextType<C> {
  return definition;
}
